<template>
  <MediaFinder />
</template>

<script>
import MediaFinder from '@/components/Settings/Media/MediaFinder.vue';
export default {
    name: 'MediaManagement',
    components: {
        MediaFinder
    }
}
</script>

<style>

</style>